import { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
} from '@chakra-ui/react';
import { useRouter } from 'next/router';

const PrsProgramFinderModal = ({
  lang,
  region,
  sectionContent,
  pageData,
  pageName,
  prgData,
  width = '1000px',
  height = '532px',
  isOpen,
  onClose,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const router = useRouter();
  useEffect(() => {
    if (router?.asPath?.indexOf('#in-person-program-finder') > -1) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [router?.asPath]);

  const handleModalClose = () => {
    setShowPopup(false);
    router.push(`${router.asPath.split('#')[0]}`);
  };
  return (
    <>
      <Modal
        isOpen={isOpen || showPopup}
        onClose={onClose || handleModalClose}
        isCentered
        size={{ base: 'full', md: 'null' }}
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          maxW={width}
          maxH={{ base: '100vh', sm: '100vh', md: height }}
          background="#fff"
          borderRadius={0}
          p={0}
          m={0}
        >
          <ModalHeader
            textAlign="start"
            color={'#3B444B'}
            bg={'#D8C8A7'}
            // fontSize={{ base: 'lg', md: 'xl' }}
            fontSize={'25px'}
            height={'90px'}
            fontFamily="FedraSansStd-medium"
          >
            Upcomming Inner Engineering Programs
            {/* supposed to come from dato */}
            <ModalCloseButton size="lg" top={4} right={4} />
          </ModalHeader>

          <ModalBody p={0}>
            <Box
              as="iframe"
              allowFullScreen
              sx={{
                width: '100%',
                height: height,
              }}
              src={
                'https://online.innerengineering.com/en/search/embed?showFilter=location'
              }
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PrsProgramFinderModal;
